var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_11326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 24.6071C20.4285 24.6071 24.6071 20.4286 24.6071 13C24.6071 5.57143 20.4285 1.39286 13 1.39286C5.57139 1.39286 1.39282 5.57143 1.39282 13C1.39282 20.4286 5.57139 24.6071 13 24.6071Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4206 10.2997L10.3572 11.908M14.4206 15.7003L10.3572 14.092",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4282 11.375C17.8211 11.375 18.6066 10.5894 18.6066 9.19472C18.6066 7.80186 17.8229 7.01629 16.4282 7.01629C15.0316 7.01629 14.2479 7.8 14.2479 9.19472C14.2479 10.5894 15.0316 11.375 16.4282 11.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4282 18.9837C17.8211 18.9837 18.6066 18.2 18.6066 16.8053C18.6066 15.4106 17.8229 14.625 16.4282 14.625C15.0316 14.625 14.2479 15.4106 14.2479 16.8053C14.2479 18.1981 15.0316 18.9837 16.4282 18.9837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.35338 15.1673C9.7481 15.1673 10.5337 14.3817 10.5337 12.987C10.5337 11.5923 9.7481 10.8067 8.35338 10.8067C6.95867 10.8067 6.1731 11.5923 6.1731 12.987C6.1731 14.3817 6.95867 15.1673 8.35338 15.1673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4282 11.375C17.8211 11.375 18.6066 10.5894 18.6066 9.19472C18.6066 7.80186 17.8229 7.01629 16.4282 7.01629C15.0316 7.01629 14.2479 7.8 14.2479 9.19472C14.2479 10.5894 15.0316 11.375 16.4282 11.375Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4282 18.9837C17.8211 18.9837 18.6066 18.2 18.6066 16.8053C18.6066 15.4106 17.8229 14.625 16.4282 14.625C15.0316 14.625 14.2479 15.4106 14.2479 16.8053C14.2479 18.1981 15.0316 18.9837 16.4282 18.9837Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35338 15.1673C9.7481 15.1673 10.5337 14.3817 10.5337 12.987C10.5337 11.5923 9.7481 10.8067 8.35338 10.8067C6.95867 10.8067 6.1731 11.5923 6.1731 12.987C6.1731 14.3817 6.95867 15.1673 8.35338 15.1673Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_11326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e282af488eb0bb39fcac7e04e88056be.svg";
export { ForwardRef as ReactComponent };